import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import logoImage from "./logo.png";
import "./header.css";

export default class Header extends Component {
  render() {
    const { subtitle } = this.props;
    return (
      <Row className="header">
        <Col sm={12} md={4} mdPush={8}>
          <div className="logo">
            <img alt="" src={logoImage} />
          </div>
        </Col>
        <Col sm={12} md={8} mdPull={4}>
          <div className="title">AFC MUSWELL HILL</div>
          {subtitle && <div className="subtitle">{subtitle}</div>}
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/header/index.js